/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  'use strict';

  function getQuantityInput(widget) {
    var form = widget.closest('form');
    return form ? form.querySelector('[name="quantity"]') : null;
  }

  function getTiers(widget) {
    return Array.prototype.slice.call(widget.querySelectorAll('[data-volume-quantity]')).map(function (tier) {
      return {
        element: tier,
        quantity: parseInt(tier.getAttribute('data-volume-quantity'), 10),
        discount: parseInt(tier.getAttribute('data-volume-discount'), 10)
      };
    }).filter(function (tier) {
      return !isNaN(tier.quantity) && !isNaN(tier.discount);
    }).sort(function (a, b) {
      return a.quantity - b.quantity;
    });
  }

  function pluralizeItems(count) {
    return count === 1 ? 'item' : 'items';
  }

  function updateVolumeOffer(widget) {
    var input = getQuantityInput(widget);
    var tiers = getTiers(widget);

    if (!input || !tiers.length) {
      return;
    }

    var quantity = Math.max(1, parseInt(input.value, 10) || 1);
    var activeTier = null;
    var nextTier = null;

    tiers.forEach(function (tier) {
      if (quantity >= tier.quantity) {
        activeTier = tier;
      } else if (!nextTier) {
        nextTier = tier;
      }
    });

    tiers.forEach(function (tier) {
      var isActive = tier === activeTier;
      tier.element.classList.toggle('is-active', isActive);
      tier.element.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    widget.classList.toggle('has-volume-savings', Boolean(activeTier));

    var status = widget.querySelector('[data-volume-status]');
    if (status) {
      if (nextTier && activeTier) {
        var upgradeCount = nextTier.quantity - quantity;
        status.textContent = "You're saving " + activeTier.discount + '%! Add ' + upgradeCount + ' more ' + pluralizeItems(upgradeCount) + ' to save ' + nextTier.discount + '%.';
      } else if (nextTier) {
        var firstCount = nextTier.quantity - quantity;
        status.textContent = 'Add ' + firstCount + ' more ' + pluralizeItems(firstCount) + ' to save ' + nextTier.discount + '%!';
      } else if (activeTier) {
        status.textContent = "Best deal unlocked — you're saving " + activeTier.discount + '%!';
      }
    }

    var progress = widget.querySelector('[data-volume-progress]');
    if (progress) {
      var maximum = tiers[tiers.length - 1].quantity;
      var progressValue = maximum > 1 ? ((Math.min(quantity, maximum) - 1) / (maximum - 1)) * 100 : 100;
      progress.style.width = Math.max(0, Math.min(100, progressValue)) + '%';
    }
  }

  function initVolumeOffers(root) {
    var scope = root || document;
    var widgets = scope.matches && scope.matches('[data-volume-offer]') ? [scope] : scope.querySelectorAll('[data-volume-offer]');
    Array.prototype.forEach.call(widgets, updateVolumeOffer);
  }

  document.addEventListener('click', function (event) {
    var tier = event.target.closest('[data-volume-quantity]');

    if (tier) {
      var widget = tier.closest('[data-volume-offer]');
      var input = widget ? getQuantityInput(widget) : null;

      if (input) {
        input.value = Math.max(1, parseInt(tier.getAttribute('data-volume-quantity'), 10) || 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
        updateVolumeOffer(widget);
      }

      return;
    }

    var quantityButton = event.target.closest('[data-action="decrease-picker-quantity"], [data-action="increase-picker-quantity"]');
    if (quantityButton) {
      var form = quantityButton.closest('form');
      var offer = form ? form.querySelector('[data-volume-offer]') : null;
      if (offer) {
        window.requestAnimationFrame(function () {
          updateVolumeOffer(offer);
        });
      }
    }
  });

  document.addEventListener('input', function (event) {
    if (!event.target.matches('[name="quantity"]')) {
      return;
    }

    var form = event.target.closest('form');
    var widget = form ? form.querySelector('[data-volume-offer]') : null;
    if (widget) {
      updateVolumeOffer(widget);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    initVolumeOffers(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initVolumeOffers(event.target);
  });
})();

(function () {
  'use strict';

  var mobileQuery = window.matchMedia('(max-width: 640px)');

  function syncProductReviewWidget() {
    var mobileHost = document.querySelector('.choco-mobile-review-host');
    var desktopHome = document.querySelector('.choco-review-widget-home');
    var widget = document.getElementById('judgeme_product_reviews');

    if (!mobileHost || !desktopHome || !widget) {
      return;
    }

    if (mobileQuery.matches) {
      if (widget.parentNode !== mobileHost) {
        mobileHost.appendChild(widget);
      }
    } else if (widget.previousElementSibling !== desktopHome) {
      desktopHome.insertAdjacentElement('afterend', widget);
    }
  }

  syncProductReviewWidget();
  document.addEventListener('DOMContentLoaded', syncProductReviewWidget);
  document.addEventListener('shopify:section:load', syncProductReviewWidget);

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', syncProductReviewWidget);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(syncProductReviewWidget);
  }
})();
